export default __webpack_public_path__ + "static/media/logo_avalanche.91e893db.svg";